import { render, staticRenderFns } from "./BillInfoSkeleton.vue?vue&type=template&id=3781d22c"
import script from "./BillInfoSkeleton.vue?vue&type=script&lang=js"
export * from "./BillInfoSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports